// eslint-disable-next-line max-classes-per-file
import { MapExtent } from "~app/common/components/map/map.models";
import { ArbetsorderDetail as LegacyArbetsorderDetail } from "~app/features/planera/model/ArbetsorderDetail";
import { IArbetsorderDetail as ILegacyArbetsorderDetail } from "~app/features/planera/model/IArbetsorderDetail";
import { IAtgardBarighetChanged as ILegacyAtgardBarighetChanged } from "~app/features/planera/model/IAtgardBarighetChanged";
import { ISaveArbetsorderRequest as ILegacySaveArbetsorderRequest } from "~app/features/planera/model/ISaveArbetsorderRequest";
import { ISaveArbetsorderResponse as ILegacySaveArbetsorderResponse } from "~app/features/planera/model/ISaveArbetsorderResponse";

/* eslint-disable no-bitwise */
export enum ArbetsorderDisabledFlag {
    none = 0,
    sparrad = 1,
    makulerad = 2 << 0
}

export class ArbetsorderWrapper {

    get id(): number | undefined {
        return this.arbetsorderInternal?.id;
    }

    get arbetsorder(): IArbetsorderDetail {
        return this.arbetsorderInternal;
    }

    get metadata(): IArbetsorderMetadata {
        return this.metadataInternal;
    }

    constructor(
        private arbetsorderInternal: IArbetsorderDetail,
        private readonly metadataInternal: IArbetsorderMetadata) {
    }

    setArbetsorder(arbetsorder: IArbetsorderDetail): void {
        this.arbetsorderInternal = arbetsorder;
    }
}
export class ArbetsorderReloadProperties {
    withWarning: boolean;
    constructor(withWarning: boolean) {
        this.withWarning = withWarning;
    }
}

export interface IPreviousArbetsorder {
    id: number;
    rowVersion: string;
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface IArbetsorderDetail extends ILegacyArbetsorderDetail { }

export interface IArbetsorderMetadata {
    id: number;
    extent: MapExtent;
}

export class ArbetsorderDetail extends LegacyArbetsorderDetail { }

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface ISaveArbetsorderRequest extends ILegacySaveArbetsorderRequest {}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface ISaveArbetsorderResponse extends ILegacySaveArbetsorderResponse {}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface IAtgardBarighetChanged extends ILegacyAtgardBarighetChanged {}

export interface IArbetsorderChanged {
    arbetsorderWrapper: ArbetsorderWrapper;
    previousArbetsorder: IPreviousArbetsorder;
    isUpdated(): boolean;
    isClosed(): boolean;
    isDifferent(): boolean;
}

export class ArbetsorderChanged implements IArbetsorderChanged {
    arbetsorderWrapper: ArbetsorderWrapper;
    previousArbetsorder: IPreviousArbetsorder;

    constructor(next: ArbetsorderWrapper, prevId: number, prevRowVersion: string) {
        this.arbetsorderWrapper = next;

        this.previousArbetsorder = {
            id: prevId,
            rowVersion: prevRowVersion
        };
    }

    isDifferent(): boolean {
        return this.arbetsorderWrapper?.arbetsorder?.id &&
        this.arbetsorderWrapper.arbetsorder?.id !== this.previousArbetsorder?.id;
    }

    isUpdated(): boolean {
        return this.arbetsorderWrapper?.arbetsorder?.id &&
        this.arbetsorderWrapper?.arbetsorder?.id === this.previousArbetsorder?.id &&
        this.arbetsorderWrapper?.arbetsorder?.rowVersion !== this.previousArbetsorder?.rowVersion;
    }

    isClosed(): boolean {
        return !(this.arbetsorderWrapper?.arbetsorder?.id);
    }
}
